module.exports = __webpack_public_path__ + "static/media/Logo-GobiernoCorrientes-300x52.2a1b410c.png";